export default "__VITE_ASSET__DlXFFjys__"